/**
 * Vite env vars set by `npm run start:integration` / `scripts/integration-local.sh`
 * when running Playwright against a local API with INTEGRATION_AUTH_BYPASS=1.
 */
export type IntegrationAuthConfig = {
  userId: string;
  email?: string;
};

export const getIntegrationAuthConfig = (): IntegrationAuthConfig | null => {
  const userId = import.meta.env.VITE_INTEGRATION_AUTH_USER_ID as
    | string
    | undefined;
  if (!userId?.trim()) {
    return null;
  }

  const email = import.meta.env.VITE_INTEGRATION_AUTH_USER_EMAIL as
    | string
    | undefined;

  return {
    userId: userId.trim(),
    email: email?.trim() || undefined,
  };
};

export const isIntegrationAuthEnabled = (): boolean =>
  getIntegrationAuthConfig() != null;
